<template>
  <div class="action-plan-boilermaking-form">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <p class="lead">{{ !printing ? 'Definir' : ''}} Detalhes do Serviço de Caldeiraria</p>
          <div v-if="!printing" class="d-flex">
            <router-link
              to="/action-plan/form"
              class="btn btn-success"
            >
              <font-awesome-icon :icon="['fas', 'arrow-left']"></font-awesome-icon>
              Voltar ao Plano de Ação
            </router-link>
            <div class="save-button ml-3">
              <button @click="save()" class="btn btn-primary">Definir</button>
            </div>
          </div>
        </div>

        <div class="col-12 d-flex justify-content-center">
          <div class="mt-4 w-50">
            <div class="col-12 col-md-12 break-after">
              <div class="form-group">
                <div class="form-title mb-2">Selecionar modelo de proteção desejado</div>

                <custom-option-selector
                  :options="BOILERMAKING_PROTECTION_MODEL_OPTIONS"
                  :value="desiredProductionModel"
                  @item-selected-event="setDesiredProductionModel"
                />

                <div class="form-check mt-2">
                  <input
                    v-model="desiredProductionModel"
                    class="form-radio-input"
                    type="radio"
                    data="desiredProductionModel"
                    id="footer"
                    value="footer"
                  />
                  <label class="form-check-label ml-2" for="footer"> Rodapé </label>
                </div>

                <div class="form-check">
                  <input
                    v-model="desiredProductionModel"
                    class="form-radio-input"
                    type="radio"
                    data="desiredProductionModel"
                    id="railing"
                    value="railing"
                  />
                  <label class="form-check-label ml-2" for="railing">
                    Guarda-corpo
                  </label>
                </div>

                <div class="form-check">
                  <input
                    v-model="desiredProductionModel"
                    class="form-radio-input"
                    type="radio"
                    data="desiredProductionModel"
                    id="footer_and_railing"
                    value="footer_and_railing"
                  />
                  <label class="form-check-label ml-2" for="footer_and_railing">
                    Rodapé + Guarda-corpo
                  </label>
                </div>
              </div>

              <div class="form-group">
                <label
                  >Metragem linear aproximada
                  <span class="font-size-0-7 ml-3"
                    >*Considerar margem de erro permitida de 10% do total</span
                  >
                </label>
                <input
                  v-model="approximatedLinearMeasurement"
                  type="text"
                  class="form-control"
                />
              </div>

              <div class="form-group">
                <label>Descrição detalhada do serviço</label>
                <textarea
                  v-model="detailedServiceDescription"
                  type="text"
                  class="form-control"
                  rows="8"
                  style="height: auto"
                ></textarea>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import CustomOptionSelector from './components/CustomOptionSelector'
  import useSwal from '@/modules/Swal.js'

  import { BOILERMAKING_PROTECTION_MODEL_OPTIONS } from '@/constants/boilermaking-protection-model-options.constants.js'

  import { useRoute } from 'vue-router'

  export default {
    setup(props) {
      const { params } = useRoute()

      const riskAnalysisDescriptionId = params.riskAnalysisDescriptionId || props.riskAnalysisDescriptionId

      const { showSuccessDialog } = useSwal()

      return {
        BOILERMAKING_PROTECTION_MODEL_OPTIONS,
        showSuccessDialog,
        riskAnalysisDescriptionId,
      }
    },
    components: {
      CustomOptionSelector,
    },
    props: {
      riskAnalysisDescriptionId: {
        type: Number,
        required: false,
      },
      printing: {
        type: Boolean,
        default: false,
        required: false,
      }
    },
    data() {
      return {
        consultancy: false,

        approximatedLinearMeasurement: '',
        detailedServiceDescription: '',

        desiredProductionModel: null,

        loading: false,
      }
    },
    methods: {
      save() {
        let payload = {
          risk_analysis_description_id: this.riskAnalysisDescriptionId,
          boilermaking: {
            needs_consultancy: this.consultancy,
            boilermaking_protection_model_id: this.desiredProductionModel,
            description: this.detailedServiceDescription,
            footer_railing: '',
            linear_measurement: this.approximatedLinearMeasurement,
          },
        }
        this.axios
          .post(`/api/action-plan/services/boilermaking`, payload)
          .then(() => this.showSuccessDialog())
      },
      setDesiredProductionModel(event) {
        this.desiredProductionModel = event.selected
      },
      load() {
        this.loading = true

        this.axios
          .get(
            `/api/action-plan/services/${this.riskAnalysisDescriptionId}/boilermaking`,
          )
          .then(({ data }) => {
            const service = data.boilermaking_services[0]

            this.consultancy = data.needs_consultancy
            this.approximatedLinearMeasurement = service.linear_measurement
            this.detailedServiceDescription = service.description

            this.desiredProductionModel =
              service.boilermaking_protection_model_id
                ? service.boilermaking_protection_model_id
                : service.footer_railing
          })
          .catch((error) => {
            console.log({ error })
          })
          .finally(() => (this.loading = false))
      },
    },
    mounted() {
      this.load()
    },
  }
</script>

<style lang="scss" scoped>
  .form-group {
    @media print {
      columns: 1;
    }
  }
</style>
